
  export default {
    name: 'SectionHeadlineWithTextAndHorizontalCards',
    components: {
      HorizontalCardWithImageAndButton: () =>
        import('@/components/elements/HorizontalCardWithImageAndButton'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey: function (props) {
      return (
        'section-headline-with-text-and-horizontal-card-' + props.section.id
      );
    },
  };
